import React from 'react'
import Cookies from 'js-cookie';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
// import PickEstateWidget from './pick_estate_widget';


function CheckSubcriptionPackageWidget() {
const accesTokenValue = Cookies.get('userAccessToken');
// const facilityIdValue = Cookies.get('facilityId');
//       <Pane>
//         <Dialog
//           isShown={isShown}
//           title="No footer"
//           onCloseComplete={() => setIsShown(false)}
//           hasHeader={false}
//           shouldCloseOnOverlayClick={false}
//           shouldCloseOnEscapePress={false}
//           hasFooter ={false}
//           width={150}
//         >
//             <center>
//                 <br/>
//                <Spinner/>
//                <br/>

//             </center>
//         </Dialog>
  
//       </Pane>


    return (

        <div>
            {/* {(facilityIdValue=== undefined || facilityIdValue.length ===0) && */}
                {/* // <PickEstateWidget/>
            // } */}
            { (accesTokenValue === undefined || accesTokenValue.length <=0) &&
                <Redirect to="/" />
            }
        </div>
    )

}

export default CheckSubcriptionPackageWidget